<template>
  <div class="d-flex align-items-center justify-content-center vh-100">
    <div class="text-center">
      <h1>🚧 Maintenance Mode</h1>
      <p class="mt-3">{{ message }}</p>
      <small class="text-muted d-block mt-2">
        Checking system status automatically…
      </small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Maintenance',

  data() {
    return {
      message: 'Application is under maintenance',
      intervalId: null,
    };
  },

  mounted() {
    // load message once
    const apiMsg = sessionStorage.getItem('maintenance_message');
    if (apiMsg) {
      this.message = apiMsg;
    } else {
      const localMsg = localStorage.getItem('maintenance_message');
      if (localMsg) {
        this.message = localMsg;
      }
    }
  },

  /* ✅ START polling ONLY when route ENTERS */
  beforeRouteEnter(to, from, next) {
    if (to.path === '/maintenance') {
      next(vm => vm.startPolling());
    } else {
      next();
    }
  },

  /* ✅ STOP polling when route LEAVES */
  beforeRouteLeave(to, from, next) {
    this.stopPolling();
    next();
  },

  methods: {
    startPolling() {
      if (this.intervalId) return;

      // immediate check
      this.checkMaintenance();

      // ⏱ every 10 minutes (use 30000 only for testing)
      this.intervalId = setInterval(() => {
        this.checkMaintenance();
      }, 600000);
    },

    stopPolling() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },

    async checkMaintenance() {
      try {
        const url = this.$store.getters.getAPIKey.userDetails;
        const response = await this.$axios.get(url);

        // Maintenance OFF
        if (response.status === 200) {
          sessionStorage.removeItem('maintenance_message');
          localStorage.removeItem('maintenance_message');

          this.stopPolling();
          this.$router.replace('/');
        }
      } catch (e) {
        // ignore errors
      }
    },
  },
};
</script>
